import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.routes').then(r => r.loginRoutes)
  },
  {
    path: 'signup',
    loadChildren: () => import('./modules/signup/signup.routes').then(r => r.signupRoutes)
  },
  {
    path: 'recovery',
    loadChildren: () => import('./modules/recovery/recovery.routes').then(r => r.recoveryRoutes)
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/main/main.routes').then(r => r.mainRoutes)
  },
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  { path: '**', redirectTo: 'admin/404' }
];
